import { InjectionToken } from '@angular/core';
import { environment } from '@spa/environment';

export const IsDev = new InjectionToken<boolean>('Is development environment', {
	providedIn: 'root',
	factory: () => !environment.production,
});
